import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api } from '../../api.ts';
import { InvoiceView, type Invoice } from '../../components/InvoiceView.tsx';

export function AdminInvoicePage() {
  const { id } = useParams();
  const [invoice, setInvoice] = useState<Invoice | null | 'missing'>(null);

  useEffect(() => {
    api.get<{ invoice: Invoice }>(`/admin/referral-invoices/${id}`).then((r) => setInvoice(r.invoice)).catch(() => setInvoice('missing'));
  }, [id]);

  return (
    <div>
      <Link to="/admin/referrers" className="no-print" style={{ fontSize: 13, fontWeight: 700, color: 'var(--accent-dark)', textDecoration: 'none', display: 'inline-block', marginBottom: 14 }}>
        ← Retour aux apporteurs
      </Link>
      {invoice === null && <div className="empty-state">Chargement…</div>}
      {invoice === 'missing' && <div className="error-banner">Facture introuvable.</div>}
      {invoice && invoice !== 'missing' && <InvoiceView invoice={invoice} />}
    </div>
  );
}
